<button class="text-true-blue resident-menu-btn" [matMenuTriggerFor]="residentMenu">Resident</button>
<mat-menu #residentMenu="matMenu" class="">
  <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="accent" (click)="onLeaseClick()">RESIDENT DOCUMENTS</button>
  </button>
  <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="disabled" class="p-0 text-right">RESIDENT DOCUMENTS</button>
  </button>
  <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="accent" (click)="onRenewalClick()">RENEWAL OFFERS</button>
  </button>
  <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="disabled" class="p-0 text-right">RENEWAL OFFERS</button>
  </button>
  <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="accent" (click)="onMaintenanceClick()">MAINTENANCE</button>
  </button>
  <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
    <button mat-button color="disabled" class="p-0 text-right">MAINTENANCE</button>
  </button>
  <button class="flex justify-end items-center pb-2" mat-menu-item>
    <button mat-button color="accent" (click)="onSmartHomeClick()">SMART HOME</button>
  </button>
</mat-menu>
